import { useTranslation } from 'next-i18next'
import NewspaperIcon from 'assets/icons/nucleo/18px_newspaper.svg'
import { NavigationItem } from 'components/Layout/Header/DisciplineContent/NavigationItem'
import { minWidthIcon } from 'components/Layout/Header/Header.style'
import { NextLinkWithoutDecoration } from 'components/common/Link'

export const MagButton = () => {
  const { t } = useTranslation('common')
  return (
    <NextLinkWithoutDecoration href="/mag" passHref>
      <NavigationItem
        leftIcon={<NewspaperIcon css={minWidthIcon} />}
        text={t('menu.mag')}
      />
    </NextLinkWithoutDecoration>
  )
}
